export default __webpack_public_path__ + "static/media/mail-icon.faaf2d79.svg";